__turbopack_context__.v({
  "dial": "xaVQha_dial",
  "dimension": "xaVQha_dimension",
  "instrument-note-enter": "xaVQha_instrument-note-enter",
  "instrumentNoteStep": "xaVQha_instrumentNoteStep",
  "particleStage": "xaVQha_particleStage",
  "registrationFrame": "xaVQha_registrationFrame",
  "source-flow-pulse": "xaVQha_source-flow-pulse",
  "sourceFlowPulse": "xaVQha_sourceFlowPulse",
});
